/* eslint-disable react/prop-types */
// import { PropTypes } from "prop-types";
/* eslint-disable jsx-a11y/anchor-has-content */

import React, { useState, useEffect, useRef } from "react";
import { graphql, useStaticQuery } from "gatsby";
import tw, { css, theme } from "twin.macro";

import * as T from "~components/styles/Typography.jsx";
import Grid from "~components/styles/Grid.jsx";
import Button from "~components/Button.jsx";
// import { fancyError, fancyLog, validateEmail } from "~utils/helpers";

const inputCSS = `
background: transparent;

::-webkit-input-placeholder {
  color: ${theme`colors.blue-dark`};
  opacity: 0.5;
}
::-moz-placeholder {
  color: ${theme`colors.blue-dark`};
  opacity: 0.5;
}
:-ms-input-placeholder {
  color: ${theme`colors.blue-dark`};
  opacity: 0.5;
}
:-moz-placeholder {
  color: ${theme`colors.blue-dark`};
  opacity: 0.5;
}
`;

const FormAnnualReport = () => {
  const {
    sanityFormAnnualReport: {
      textColor,
      backgroundColor,
      formTextColor,
      formBackgroundColor,
      header,
      subheader,
      annualReportText,
      annualReport,
      evaluationReportText,
      evaluationReport
    }
  } = useStaticQuery(graphql`
    query {
      sanityFormAnnualReport {
        textColor {
          hex
        }
        backgroundColor {
          hex
        }
        formTextColor {
          hex
        }
        formBackgroundColor {
          hex
        }
        header
        subheader

        annualReportText
        annualReport {
          asset {
            url
          }
        }

        evaluationReportText
        evaluationReport {
          asset {
            url
          }
        }
      }
    }
  `);

  return (
    <section css={[tw`w-full relative block`]}>
      <div
        css={[
          css`
            width: 50vw;
            background: ${backgroundColor?.hex || `white`};
          `,
          tw`h-full absolute top-0 left-0 bottom-0 hidden md:block`
        ]}
      />
      <div
        css={[
          css`
            width: 50vw;
            background: ${theme`colors.blue-light`};
          `,
          tw`h-full absolute top-0 right-0 bottom-0 hidden md:block`
        ]}
      />

      <Grid>
        <div
          css={[
            css`
              background: ${backgroundColor?.hex || `white`};
              color: ${textColor?.hex || `black`};
            `,
            tw`col-span-24 md:col-span-10 md:col-start-2 relative pt-12 pb-12 md:pb-20`
          ]}
        >
          <div
            css={[
              css`
                width: calc(100% + 2rem);
                left: -1rem;
                background: ${backgroundColor?.hex || `white`};
              `,
              tw`absolute top-0 bottom-0 md:hidden`
            ]}
          />

          <T.Head _css={[tw`relative z-10 mb-8`]} font="3" level="2">
            {header}
          </T.Head>

          <T.Head _css={[tw`relative z-10`]} font="5" level="3">
            {subheader}
          </T.Head>
        </div>

        <Form
          textColor={formTextColor}
          backgroundColor={formBackgroundColor}
          annualReport={{ file: annualReport, text: annualReportText }}
          evaluationReport={{
            file: evaluationReport,
            text: evaluationReportText
          }}
        />
      </Grid>
    </section>
  );
};

export default FormAnnualReport;

const Form = ({
  textColor,
  backgroundColor,
  annualReport,
  evaluationReport
}) => {
  const submitRef = useRef();
  const annualReportRef = useRef();
  const evaluationReportRef = useRef();

  const [annualCheckbox, setAnnualCheckbox] = useState(false);
  const [evaluationCheckbox, setEvaluationCheckbox] = useState(false);

  const submitProxy = () => {
    if (!submitRef?.current) {
      return;
    }

    submitRef.current.click();
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (annualCheckbox && annualReportRef?.current) {
      annualReportRef.current.click();
    }

    if (evaluationCheckbox && evaluationReportRef?.current) {
      evaluationReportRef.current.click();
    }

    return false;
  };

  return (
    <div
      css={[
        css`
          color: ${textColor?.hex || `black`};
          background: ${backgroundColor?.hex || `white`};
        `,
        tw`col-span-24 md:col-span-12 md:col-start-13 relative`
      ]}
    >
      <div
        css={[
          css`
            width: calc(100% + 2rem);
            left: -1rem;
            background: ${backgroundColor?.hex || `white`};
          `,
          tw`absolute top-0 bottom-0 md:hidden`
        ]}
      />

      <form
        css={[tw`w-full relative z-10 block pt-12 pb-12 md:p-12`]}
        onSubmit={onSubmit}
      >
        <input
          ref={submitRef}
          tw="w-0 h-0 absolute opacity-0 pointer-events-none"
          type="submit"
          hidden
        />

        <a
          ref={annualReportRef}
          tw="w-0 h-0 absolute opacity-0 pointer-events-none"
          aria-hidden="true"
          href={annualReport?.file?.asset?.url}
          download
          target="_blank"
          rel="noreferrer"
        />

        <a
          ref={evaluationReportRef}
          tw="w-0 h-0 absolute opacity-0 pointer-events-none"
          aria-hidden="true"
          href={evaluationReport?.file?.asset?.url}
          download
          target="_blank"
          rel="noreferrer"
        />

        <div
          css={[
            tw`relative flex items-start md:items-center mt-16 md:mt-8 mb-3 md:mb-2`
          ]}
        >
          <input
            css={[
              tw`w-4 h-4 relative mt-1 md:mt-0 mr-3 block cursor-pointer border`
            ]}
            type="checkbox"
            checked={annualCheckbox}
            onChange={(e) => {
              setAnnualCheckbox(e.currentTarget.checked);
            }}
          />

          <T.Body font="2">{annualReport?.text}</T.Body>
        </div>

        <div
          css={[
            tw`relative flex items-start md:items-center mt-16 md:mt-3 mb-3 md:mb-2`
          ]}
        >
          <input
            css={[
              tw`w-4 h-4 relative mt-1 md:mt-0 mr-3 block cursor-pointer border`
            ]}
            type="checkbox"
            checked={evaluationCheckbox}
            onChange={(e) => {
              setEvaluationCheckbox(e.currentTarget.checked);
            }}
          />

          <T.Body font="2">{evaluationReport?.text}</T.Body>
        </div>

        <Button
          _css={[
            tw`w-full md:w-auto`,
            !annualCheckbox &&
              !evaluationCheckbox &&
              tw`bg-transparent! opacity-50 pointer-events-none`
          ]}
          color="blue-dark"
          text="Download"
          onClick={submitProxy}
          disabled={!annualCheckbox && !evaluationCheckbox}
        />
      </form>
    </div>
  );
};
